import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { tokenManager } from "@/lib/axios";
import { useStore } from "@/stores";
import { LoadingState } from "./LoadingState";
import { hasPermission, canAccessWeb, type Permission } from "@/utils/permissions";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requirePermission?: Permission;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requirePermission,
}) => {
  const location = useLocation();
  const { user, isAuthenticated, isLoading } = useAuth();
  const { setUser } = useStore();

  // Affiche un loader pendant la vérification de l'authentification
  if (isLoading) {
    return <LoadingState message="Chargement..." size="md" />;
  }

  // Pas de token ou pas authentifié → redirection login
  if (!tokenManager.hasToken() || !isAuthenticated) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // Rôles terrain (opérateur, chef d’équipe, adjoint) : pas d’accès web
  if (user && !canAccessWeb(user.role)) {
    tokenManager.clearToken();
    setUser(null);
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // Si une permission spécifique est requise et non accordée → redirection dashboard
  if (requirePermission && !hasPermission(user?.role, requirePermission)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

